// National brands: one business working across the whole country from
// central offices (not a franchise of local owners).
// To add one, add its website (no https or www) on a new line, e.g.:
//   "bigyellow.co.uk",
export const NATIONAL_SITES = [
];
